import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Registration,
  RegistrationActivity,
  CreateRegistrationRequest,
  UpdateRegistrationRequest,
  RegistrationsListParams,
  RegistrationMetrics,
  AdvanceStageRequest
} from '../types';

const { REGISTRATIONS } = API_ENDPOINTS;

export const registrationApi = {
  getAll: (params?: RegistrationsListParams) =>
    apiClient.getPaginated<Registration>(REGISTRATIONS.LIST, params),

  getById: (id: number) => apiClient.get<Registration>(REGISTRATIONS.GET(id)),

  create: (data: CreateRegistrationRequest) =>
    apiClient.post<Registration>(REGISTRATIONS.CREATE, data),

  update: (id: number, data: UpdateRegistrationRequest) =>
    apiClient.put<Registration>(REGISTRATIONS.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(REGISTRATIONS.DELETE(id)),

  metrics: () => apiClient.get<RegistrationMetrics>(REGISTRATIONS.METRICS),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<RegistrationsListParams> }
  ) => apiClient.post(REGISTRATIONS.BULK_DELETE, params),

  getActivities: (id: number) =>
    apiClient.get<RegistrationActivity[]>(REGISTRATIONS.ACTIVITIES(id)),

  advanceStage: (id: number, data: AdvanceStageRequest) =>
    apiClient.post<Registration>(REGISTRATIONS.ADVANCE_STAGE(id), data)
};
